import { DataContainer } from './components/DataContainer';
import { useState } from 'react';
import { default as FNS } from './api';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';



const STATE_LOADING = 0;
const STATE_SUCCESS = 1;
const STATE_ALREADY_SUBMITTED = 2;
const STATE_IDLE = 3;

function EmailDriverConfirmJob(props) {
    const [ state, setState ] = useState(STATE_IDLE);
    const [searchParams] = useSearchParams();

    const id = searchParams.get('id');
    const confirmationKey = searchParams.get('confirmation_key');
    const driver = searchParams.get('driver');
    const isPositiveResponse = !!(+searchParams.get('response'));
    console.log("isPositiveResponse", isPositiveResponse);

    async function submit() {
        const { alreadyAnswered } = await FNS.emailDriverConfirmJob(id, confirmationKey, +isPositiveResponse, driver);
        setState(alreadyAnswered ? STATE_ALREADY_SUBMITTED : STATE_SUCCESS);
        if(!alreadyAnswered) toast.success("Vastus salvestatud");
    }

    switch(state) {
        case STATE_IDLE: return (

            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <p style={{ textAlign: 'center', fontSize: 21 }}>{isPositiveResponse ? "Soovin kinnitada tööd" : "Soovin keelduda tööst"}</p>
                <button onClick={submit} style={{ backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff', fontSize: 21 }}>{isPositiveResponse ? "Kinnita" : "Keeldu"}</button>
            </div>

        );
        case STATE_LOADING: return (

            <DataContainer forceLoading={true} >
                <div style={{ width: '100%', minHeight: '100vh' }}></div>
            </DataContainer>

        );
        case STATE_SUCCESS: return (

            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Tehtud!</h1>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_604_139)"><circle cx="32" cy="32" r="32" fill="#65D190"/><path d="M9.37259 32.0001L15.0294 26.3432L26.3432 37.6569L48.9706 15.0295L54.6274 20.6864L26.3432 48.9707L9.37259 32.0001Z" fill="white"/></g><defs><clipPath id="clip0_604_139"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                <p style={{ textAlign: 'center' }}>{isPositiveResponse ? "Töö on edukalt kinnitatud." : "Keeldumisest on logistikut teavitatud."}</p>
                <a href="https://abuss.ee" style={{ backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff' }}>Avalehele</a>
            </div>

        );
        case STATE_ALREADY_SUBMITTED: return (
            <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
                <h1 className="title">Tehtud!</h1>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_604_139)"><circle cx="32" cy="32" r="32" fill="#65D190"/><path d="M9.37259 32.0001L15.0294 26.3432L26.3432 37.6569L48.9706 15.0295L54.6274 20.6864L26.3432 48.9707L9.37259 32.0001Z" fill="white"/></g><defs><clipPath id="clip0_604_139"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
                <p style={{ textAlign: 'center' }}>Olete juba vastanud.</p>
                <a href="https://abuss.ee" style={{ backgroundColor: '#88f', borderRadius: 4, padding: 8, paddingInline: 16, color: '#fff' }}>Avalehele</a>
            </div>

        );
        default: return null;
    }

}

export default EmailDriverConfirmJob;